// A WIP Applet mapper to help normalize gql data with properties we expect from rails Web::Applet model

export const fromGraphApplet = rawApplet => ({
  ...rawApplet.normalized_applet,
  uniq_permissions: [
    ...new Set(
      rawApplet.normalized_applet.permissions.filter(
        s => s.channel.module_name !== rawApplet.normalized_applet.service_slug
      )
    ),
  ],
})
